import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken =
    'pk.eyJ1IjoiY29yYWxjb2FzdCIsImEiOiJjbGFtNGJxN3cwOGRoM3NwZng0MGNzdGpkIn0.jauhTNc6SeIwit2ZJZkmVg';

//const mapBox = document.querySelector('.map');

const maps = Array.from(document.querySelectorAll('.itinerary-map'));
//let hoveredStateId = null;
let popup = null;
let popUpContainer = null;
let openedPopupLabel = null;
let selectedModeOfTransport = 'driving';

if (maps.length) {
    document.getElementsByTagName('HTML')[0].style.scrollBehavior = 'smooth';
    maps.forEach((mapBox) => {
        const mapId = mapBox.id;
        const mapStyle = mapBox.dataset.style;
        const mapCenterLng = mapBox.dataset.centerLng;
        const mapCenterLat = mapBox.dataset.centerLat;
        const mapItineraries = JSON.parse(mapBox.dataset.mapItineraries);
        let features = [];
        let directionCoordinates = null;
        let currentCenter = null;
        let googleDirectionsCoordinates = '';

        const mq = window.matchMedia('(min-width: 48rem)');

        let mapMinZoom = mq.matches
            ? mapBox.dataset.minZoom
            : mapBox.dataset.minZoomMobile ?? mapBox.dataset.minZoom;
        let mapMaxZoom = mq.matches
            ? mapBox.dataset.maxZoom
            : mapBox.dataset.maxZoomMobile ?? mapBox.dataset.maxZoom;
        let mapCurrentZoom = mq.matches
            ? mapBox.dataset.currentZoom
            : mapBox.dataset.currentZoomMobile ?? mapBox.dataset.currentZoom;

        const directionButton = document.getElementsByClassName(
            'itinerary-details__item-direction-button'
        )[0];
        const distanceLabel = document.querySelector('.itinerary-details__item-distance span');
        if (distanceLabel) {
            distanceLabel.classList.add('is-loading');
        }

        if (directionButton) {
            directionButton.addEventListener('click', getLocationAndDirections);
        }

        function getLocationAndDirections() {
            directionButton.classList.add('is-loading');
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(launchDirections);
            } else {
                alert('Geolocation is not supported by this browser.');
            }
        }

        function launchDirections(position) {
            directionButton.classList.remove('is-loading');
            window
                .open(
                    `https://www.google.com/maps/dir/' +
                    ${position.coords.latitude} ,
                    ${position.coords.longitude} 
                    ${googleDirectionsCoordinates}`,
                    '_blank'
                )
                .focus();
        }

        if (mapItineraries) {
            // Iterate map iteneraries into pin data
            features = Array.from(mapItineraries).map((pin, index) => ({
                id: index + 1,
                type: 'Feature',
                geometry: {
                    coordinates: [parseFloat(pin.pinCenterLng), parseFloat(pin.pinCenterLat)],
                    type: 'Point'
                },
                properties: {
                    id: index + 1,
                    label: pin.label,
                    description: pin.description,
                    image: pin.image,
                    link: pin.link,
                    marker: 'pin-default',
                    textOffset: [0, -0.9],
                    fontSize: 13
                }
            }));

            // Loop through map itineraries and construct directionCoordinates to use for api call
            features.forEach(function (value, index) {
                const valueLat = value.geometry.coordinates[1];
                const valueLon = value.geometry.coordinates[0];

                if (index === features.length - 1) {
                    directionCoordinates = directionCoordinates + valueLon + ',' + valueLat;
                } else {
                    directionCoordinates = directionCoordinates + valueLon + ',' + valueLat + ';';
                }

                googleDirectionsCoordinates =
                    googleDirectionsCoordinates + '/' + valueLat + ',' + valueLon;
            });
        }

        // Define features as geojson data
        const pinData = {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: features
            }
        };

        let styleUrl = 'mapbox://styles/' + mapStyle;

        // Declare new instance of map
        const map = new mapboxgl.Map({
            container: mapId,
            style: styleUrl,
            center: [mapCenterLng, mapCenterLat], // starting position [lng, lat]
            zoom: mapCurrentZoom, // starting zoom
            minZoom: parseInt(mapMinZoom),
            maxZoom: parseInt(mapMaxZoom),
            cooperativeGestures: true,
            projection: 'mercator'
        });

        //invalidate mapbox's cache
        styleUrl = styleUrl + '?version=20241203';
        map.setStyle(styleUrl);

        // Disable scroll and double click zoom, add navigation controls
        // map.scrollZoom.disable();
        map.doubleClickZoom.disable();

        const navControl = new mapboxgl.NavigationControl({
            visualizePitch: true
        });
        map.addControl(navControl, 'bottom-right');

        map.on('load', function () {
            //find iconlayer in style
            const layers = map.getStyle().layers;
            // Find the index of the first itinenary icons layer in the map style.
            let iteneraryIconsLayerId;
            for (const layer of layers) {
                if (layer.id.includes('itinenary-icons')) {
                    iteneraryIconsLayerId = layer.id;
                    break;
                }
            }
            // Load images for pin markers
            let pinsPath = '/themes/coralcoast/images/mapbox/pins/';
            map.loadImage(pinsPath + 'pin-default.png?v2', function (error, image) {
                if (error) throw error;
                map.addImage('pin-default', image);
            });
            map.loadImage(pinsPath + 'pin-default-hover.png?v2', function (error, image) {
                if (error) throw error;
                map.addImage('pin-default-hover', image);
            });

            // Add data source pinData to Map
            map.addSource('places', pinData);

            map.on('click', 'places-points-layer', function (e) {
                var id = e.features[0].id;
                openPopup(id);
            });

            function openPopup(id) {
                let selectedFeature = features.filter((f) => f.id == id)[0];
                var coordinates = selectedFeature.geometry.coordinates.slice();
                var label = selectedFeature.properties.label;
                var link = selectedFeature.properties.link;
                var image = selectedFeature.properties.image.url;
                var zoom = 15;
                var pitch = 60;
                var bearing = 45;

                currentCenter = selectedFeature.geometry.coordinates;
                mapCurrentZoom = map.getZoom();

                if (mapCurrentZoom > zoom) {
                    zoom = mapCurrentZoom;
                }

                map.flyTo({
                    center: selectedFeature.geometry.coordinates,
                    zoom: zoom,
                    pitch: pitch,
                    bearing: bearing
                });

                if (openedPopupLabel) {
                    if (openedPopupLabel !== label) {
                        popup.remove();
                    } else {
                        return false;
                    }
                }
                let isNextButton = id != features[features.length - 1].id;
                let isPrevButton = id != features[0].id;
                let prevDisabled = isPrevButton ? '' : 'disabled';
                let nextDisabled = isNextButton ? '' : 'disabled';

                popup = new mapboxgl.Popup({
                    className: 'itinerary-map__overlay-container'
                })
                    .setLngLat(coordinates)
                    .setHTML(
                        `<div class="itinerary-map__overlay"> 
                            <div class="itinerary-map__image-holder"> 
                                <a class="itinerary-map__content-link" target="_blank" href="${link}">
                                    <img class="itinerary-map__content-image" src="${image}" width="160" height="200" alt=""/>
                                </a>
                            </div> 
                            <div class="itinerary-map__content-holder flex flex-col justify-center items-center w-full md:items-start">
                                <div class="itinerary-map__content-info w-full flex justify-between items-center pr-8 md:pr-0 md:flex-col md:items-start">
                                    <a class="itinerary-map__content-link" href="#itinerary${id}">
                                        <h2 class="itinerary-map__content-title md:mb-4">${label}</h2>
                                    </a>
                                    <a class="itinerary-map__content-link itinerary-map__button" href="#itinerary${id}">
                                        <span class="border rounded-full w-8 h-8 text-center mr-2 hidden md:block">${id}</span>
                                        <span class="text-sm uppercase">
                                            <span class="hidden md:inline font-heading text-grey-400 uppercase tracking-medium font-medium">View Details</span>
                                        </span>
                                    </a>
                                </div>
                                <div class="itinerary-map__prev_next_container hidden absolute top-0 right-0 h-full border-l border-grey-200 md:block">
                                    <a class="flex items-center justify-center itinerary-map__next ${nextDisabled}" href="javascript:void(0)">
                                        <svg width="21" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m19.5 1.5-9 9-9-9" stroke="#bcbcb0" stroke-width="2"/></svg>
                                    </a>
                                    <a class="flex items-center justify-center border-t border-grey-200 itinerary-map__prev ${prevDisabled}" href="javascript:void(0)">
                                        <svg width="21" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m19.5 1.5-9 9-9-9" stroke="#bcbcb0" stroke-width="2"/></svg>
                                    </a>

                                </div>
                            </div>
                        </div>`
                    )
                    .addTo(map);

                openedPopupLabel = label;

                if (isPrevButton) {
                    document
                        .getElementsByClassName('itinerary-map__prev')[0]
                        .addEventListener('click', () => {
                            openPopup(id - 1);
                        });
                }

                if (isNextButton) {
                    document
                        .getElementsByClassName('itinerary-map__next')[0]
                        .addEventListener('click', () => {
                            openPopup(id + 1);
                        });
                }

                popup.on('close', function () {
                    setTimeout(function () {
                        popUpContainer = document.getElementsByClassName('mapboxgl-popup')[0];
                        if (popUpContainer) {
                            return false;
                        } else {
                            map.flyTo({
                                center: currentCenter,
                                zoom: mapCurrentZoom,
                                pitch: 0,
                                bearing: 0
                            });
                            openedPopupLabel = null;
                        }
                    }, 200);
                });
            }

            map.on('mousemove', 'places-points-layer', function (e) {
                map.getCanvas().style.cursor = 'pointer';
                map.setLayoutProperty('places-points-layer', 'icon-image', [
                    'match',
                    ['id'],
                    e.features[0].id,
                    'pin-default-hover', //image when id is the hovered feature id
                    'pin-default' // default
                ]);
                map.setPaintProperty('places-label-layer', 'text-color', [
                    'match',
                    ['id'],
                    e.features[0].id,
                    '#26363C', //color when id is the hovered feature id
                    '#ffffff' // default
                ]);
            });

            map.on('mouseleave', 'places-points-layer', function () {
                map.getCanvas().style.cursor = '';
                map.setLayoutProperty('places-points-layer', 'icon-image', 'pin-default');
                map.setPaintProperty('places-label-layer', 'text-color', '#ffffff');
            });

            const getDirectionsData = (
                directionCoordinates,
                id,
                color,
                width,
                origin,
                destination,
                modeOfTransport
            ) => {
                fetch(
                    `https://api.mapbox.com/directions/v5/mapbox/${modeOfTransport}/${directionCoordinates}?access_token=${mapboxgl.accessToken}&geometries=geojson&steps=true`
                )
                    .then((response) => response.json())
                    .then((data) => {
                        map.addSource(id + '-source', {
                            type: 'geojson',
                            data: {
                                type: 'Feature',
                                properties: {
                                    label: id,
                                    distance: (data.routes[0].distance * 0.001).toFixed(2), // convert to km,
                                    duration: (data.routes[0].duration / 3600).toFixed(2), // convert to minutes
                                    origin: origin,
                                    destination: destination
                                },
                                geometry: data.routes[0].geometry
                            },
                            generateId: true // This ensures that all features have unique IDs
                        });
                        if (distanceLabel) {
                            distanceLabel.classList.remove('is-loading');
                        }
                        const routeHours = Math.floor(data.routes[0].duration / 3600);
                        const routeMins = Math.floor((data.routes[0].duration % 3600) / 60);
                        if (distanceLabel) {
                            distanceLabel.innerHTML = `
                            ${(data.routes[0].distance * 0.001).toFixed(2)}km,
                            ${routeHours > 0 ? routeHours + 'hr' : ''}
                            ${routeMins > 0 ? routeMins + 'min' : ''}
                        `;
                        }

                        map.addLayer(
                            {
                                id: id + '-outline',
                                type: 'line',
                                source: id + '-source',
                                layout: {
                                    'line-join': 'round',
                                    'line-cap': 'round'
                                },
                                paint: {
                                    'line-color': '#fff',
                                    'line-width': 5,
                                    'line-opacity': 1
                                }
                            },
                            'custom-towns-labels'
                        );

                        map.addLayer(
                            {
                                id: id,
                                type: 'line',
                                source: id + '-source',
                                layout: {
                                    'line-join': 'round',
                                    'line-cap': 'round'
                                },
                                paint: {
                                    'line-color': color,
                                    'line-width': width,
                                    'line-opacity': 1
                                }
                            },
                            'custom-towns-labels'
                        );

                        map.moveLayer(id + '-outline', id);
                    });
            };

            const initializeDirections = (callback) => {
                //Get directions data for the whole itinerary
                getDirectionsData(
                    directionCoordinates,
                    'route-main-driving',
                    '#FFB506',
                    2,
                    null,
                    null,
                    selectedModeOfTransport
                );

                setTimeout(function () {
                    callback();
                }, 1000);
            };

            const addLayerMarkers = () => {
                map.addLayer(
                    {
                        id: 'places-points-layer',
                        type: 'symbol',
                        source: 'places',
                        layout: {
                            'icon-image': ['get', 'marker'],
                            'icon-allow-overlap': true,
                            'icon-ignore-placement': true,
                            'symbol-z-order': 'viewport-y',
                            'text-field': ['get', 'id'],
                            'text-font': ['DIN Pro Regular', 'Arial Unicode MS Bold'],
                            'text-size': ['get', 'fontSize'],
                            'text-anchor': 'top',
                            'text-offset': ['get', 'textOffset'],
                            'text-allow-overlap': true,
                            'text-ignore-placement': true
                        },
                        paint: {
                            'text-color': '#fff'
                        }
                    },
                    'custom-towns-labels'
                );

                if (iteneraryIconsLayerId) {
                    map.moveLayer(iteneraryIconsLayerId, 'places-points-layer');
                }

                map.setLayoutProperty('custom-towns-labels', 'text-ignore-placement', false);
                map.setLayoutProperty('custom-towns-labels', 'text-allow-overlap', false);
            };
            initializeDirections(addLayerMarkers);
        });
    });
}
